import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchAuthenticatedUser } from '../../redux/modules/authentication';

// HOC som ger komponenten information om användaren har redigeringsrättigheter
export const withEditRights = (WrappedComponent) => {
  const WithEditRights = ({ user, authenticated, fetchAuthenticatedUser, ...props }) => {
    const [localUser, setLocalUser] = useState(user || JSON.parse(localStorage.getItem('userProfile')));

    useEffect(() => {
      // Om vi har en autentiserad användare men ingen användardata
      if (authenticated && !localUser) {
        // Försök hämta användardata från localStorage först
        const storedUser = JSON.parse(localStorage.getItem('userProfile'));
        if (storedUser) {
          setLocalUser(storedUser);
        } else {
          // Om ingen data i localStorage, hämta från servern
          fetchAuthenticatedUser().then(response => {
            if (response && response.user) {
              localStorage.setItem('userProfile', JSON.stringify(response.user));
              setLocalUser(response.user);
            }
          });
        }
      }
      // Uppdatera localUser när user props ändras
      if (user && JSON.stringify(user) !== JSON.stringify(localUser)) {
        setLocalUser(user);
        localStorage.setItem('userProfile', JSON.stringify(user));
      }
    }, [authenticated, user, localUser, fetchAuthenticatedUser]);

    // Kontrollera om användaren är lärare
    const hasEditRights = localUser && (localUser.role === 'teacher' || localUser.role === 'admin');

    return (
      <WrappedComponent
        {...props}
        canEdit={hasEditRights}
        user={localUser}
      />
    );
  };

  WithEditRights.propTypes = {
    user: PropTypes.object,
    authenticated: PropTypes.bool,
    fetchAuthenticatedUser: PropTypes.func.isRequired
  };

  const mapStateToProps = (state) => ({
    user: state.authentication.profile,
    authenticated: state.authentication.authenticated
  });

  return connect(mapStateToProps, { fetchAuthenticatedUser })(WithEditRights);
};

export default withEditRights;